import axios from '@utils/axios';

const customerDetail = {
  state: {
    street: '',
    streetNumber: '',
    city: '',
    zipCode: '',
    gender: 2,
    email: '',
    name: '',
    surname: '',
    agreedToDataProcessing: false,
    agreedToTermsOfService: false,
    phone: { prefix: '', number: '' },
    password: '',
    productTypeId: 1,
    paidInCash: false
  },
  mutations: {
    setStreet(state, street) {
      state.street = street;
    },
    setStreetNumber(state, streetNumber) {
      state.streetNumber = streetNumber;
    },
    setCity(state, city) {
      state.city = city;
    },
    setZipCode(state, zipCode) {
      state.zipCode = zipCode;
    },
    setGender(state, gender) {
      state.gender = gender;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setName(state, name) {
      state.name = name;
    },
    setSurname(state, surname) {
      state.surname = surname;
    },
    setAgreedToDataProcessing(state, val) {
      state.agreedToDataProcessing = val;
    },
    setAgreedToTermsOfService(state, val) {
      state.agreedToTermsOfService = val;
    },
    setPhone(state, phone) {
      state.phone = phone;
    },
    setPassword(state, pass) {
      state.password = pass;
    },
    setProductTypeId(state, id) {
      state.productTypeId = id;
    },
    setPaidInCash(state, cash) {
      state.paidInCash = cash;
    }
  },
  actions: {
    resetContext(context) {
      context.commit('setStreet', '');
      context.commit('setStreetNumber', '');
      context.commit('setCity', '');
      context.commit('setZipCode', '');
      context.commit('setGender', 2);
      context.commit('setEmail', '');
      context.commit('setName', '');
      context.commit('setSurname', '');
      context.commit('setPassword', '');
      context.commit('setAgreedToDataProcessing', false);
      context.commit('setAgreedToTermsOfService', false);
      context.commit('setPhone', { prefix: '', number: '' });
      context.commit('setProductTypeId', 1);
      context.commit('setPaidInCash', false);
    },
    createCustomer(context) {
      return axios.put('admin/customers', {
        Name: context.state.name,
        Surname: context.state.surname,
        Email: context.state.email,
        Phone: context.state.phone.number,
        PhonePrefix: context.state.phone.prefix,
        Gender: context.state.gender,
        Street: context.state.street,
        StreetNumber: context.state.streetNumber,
        City: context.state.city,
        Zipcode: context.state.zipCode,
        Password: context.state.password,
        AgreeTerms: context.state.agreedToTermsOfService,
        AgreeProcessingData: context.state.agreedToDataProcessing,
        ProductTypeId: context.state.productTypeId,
        PaidInCash: context.state.paidInCash
      });
    }
  },
  namespaced: true
};

export default customerDetail;
